import React, { useState } from "react";

//UI Material
import { Breadcrumbs, Grid, Link } from "@mui/material";

//Local components
import ConnectivityDeviceSummary from "../Components/connectivity-device-page/ConnectivityDeviceSummary";
import ConnectivityDeviceInfo from "../Components/connectivity-device-page/ConnectivityDeviceInfo";
import ConnectivityDeviceLinkedStations from "../Components/connectivity-device-page/ConnectivityDeviceLinkedStations";

export default function ConnectivityDevice() {
  // ==========> Component States<==========
  //State for store device data
  const [deviceData, setDeviceData] = useState({
    id: 1,
    description: "Dispositivo de pruebas",
    IMEI: "863993062298873",
    SIM: "KOLBI-8851601092321199428",
    SSID: "ELCO-X0h4o-PA",
    accessIP: "192.168.100.1",
    adminPass: "gHKba64eG88U",
    createdAt: "2024-04-22T13:00:19Z",
    createdBy: "fmatamorosa09@icloud.com",
    macAddress: "Unknown",
    brand: "LTE",
    model: "4G Dongle",
    password: "7hd399ske3",
    stations: ["station123146"],
  });

  // ==========> Component <==========
  return (
    <Grid
      container
      spacing={1}
      justifyContent="flex-start"
      textAlign="center"
      sx={{ padding: "15px" }}
    >
      <Grid item xs={12} sx={{ mb: 1 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/inventory">
            Dispositivos
          </Link>
          <Link underline="hover" color="text.primary" aria-current="page">
            {`Dispositivo ${new URLSearchParams(window.location.search).get(
              "id"
            )}`}
          </Link>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12} md={3} xl={2}>
        <ConnectivityDeviceSummary data={deviceData} />
      </Grid>
      <Grid item xs={12} md={9} xl={10}>
        <Grid container spacing={1} alignItems="stretch" alignContent="stretch">
          <Grid item xs={12}>
            <ConnectivityDeviceInfo data={deviceData} getDevice={() => {}} />
          </Grid>
             <Grid item xs={12} md={6}>
            <ConnectivityDeviceLinkedStations data={deviceData} getDevice={() => {}} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
